import { render, staticRenderFns } from "./DataComplianceApply.vue?vue&type=template&id=0ec6ecb3&scoped=true"
import script from "./DataComplianceApply.vue?vue&type=script&lang=js"
export * from "./DataComplianceApply.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceApply.vue?vue&type=style&index=0&id=0ec6ecb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6ecb3",
  null
  
)

export default component.exports